import { render, staticRenderFns } from "./register.vue?vue&type=template&id=23870fba&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./register.vue?vue&type=style&index=1&id=23870fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23870fba",
  null
  
)

export default component.exports